<template>
<div class="projectsPage" v-bind:class="{ detailsOn: isDetailsOn }">
  <!-- Project List -->
  <div class="projectList">
    <vue-scroll :ops="ops">
      <div class="projectList__intro">
          <p>From corporate sites to more personal projects. From graphic design to full front-end integration. From static sites to more dynamic and administrable ones (Wordpress). I respond to your needs with the graphical design and web development adapted to the actual variety of devices</p>
      </div>
      <ul class="projectList__list" v-if="projectListLoaded">
          <ProjectListItem
            v-for="project in projects"
            v-bind:key ="project.id"
            v-bind:project = "project"
            v-bind:class="{ active: projectId == project.id }"
            v-on:showDetails="onShowDetails" >
          </ProjectListItem>
      </ul>
      <div v-else>
        <transition name="fade">
          <div
            class="spinner">
            <img src="../assets/img/spinner.gif" alt="">
          </div>
        </transition>
      </div>
    </vue-scroll>
  </div>
  <!-- Project Details -->
  <div class="projectDetailsContainer">
      <div class="content">
          <transition name="fade">
            <div v-if='isDetailsOn == false' class="projectDetails__intro">
              <div class="projectDetails__intro__content">
                <p>From corporate sites to more personal projects. From graphic design to full front-end integration. From static sites to more dynamic and administrable ones (Wordpress). I respond to your needs with the graphical design and web development adapted to the actual variety of devices</p>
              </div>
            </div>
          </transition>
          <div>
            <div class="closeBtnContainer">
              <a class="customBtn closeBtn"
                  @click="closeBtClickHandler()">
                  Close
                  <span class="icon fmix-cross"></span>
              </a>
            </div>
            <ProjectDetails
              v-bind:projectId = projectId>
            </ProjectDetails>
          </div>
      </div>
  </div>
</div>
</template>

<script>
import ProjectListItem from '@/components/ProjectListItem'
import ProjectDetails from '@/components/ProjectDetails'

export default {
  name: 'ProjectsPage',
  components: { ProjectListItem, ProjectDetails },
  data () {
    return {
      projects: [],
      projectId: '',
      projectListLoaded: false,
      isDetailsOn: false,
      ops: {
        rail: {
          opacity: '0'
        },
        bar: {
          background: '#666',
          opacity: 0.4
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800
        }
      }
    }
  },
  mounted () {
    // RECOVER PROJECTS LIST
    // Request projects list
    this.$http.get('wp/v2/projects?_embed&order=asc&orderby=title&per_page=100').then(response => {
      // Parse data
      response.data.forEach(project => {
        let projectData = {}
        projectData.id = project.id
        projectData.title = project.title.rendered
        projectData.client = project.acf.client
        projectData.thmbURL = project._embedded['wp:featuredmedia'][0].source_url
        this.projects.push(projectData)
      })
      // this.projects = response.data
      this.projectListLoaded = true
    }, error => {
      alert('Error: ' + JSON.stringify(error))
      this.projectListLoaded = true
    })
    // Check if parameter
    // (case we access by url to an specific project page)
    if (this.$route.params.id) {
      // Add class to indicate details are visible
      this.isDetailsOn = true
      // Recover Project Details
      this.projectId = this.$route.params.id
    }
  },
  methods: {
    onShowDetails (value) {
      // Add class to indicate details are visible
      this.isDetailsOn = true
      // Recover project id
      this.projectId = value
      // Go to project details page
      this.$router.push({name: 'ProjectDetails', params: { id: value }})
      // Scroll to top
      window.scrollTo(0, 0)
    },
    closeBtClickHandler () {
      this.isDetailsOn = !this.isDetailsOn
      this.projectId = ''
      this.$router.push({name: 'ProjectsPage'})
    }
  },
  watch: {
    '$route' (to, from) {
      // Check if project id
      if (this.$route.params.id) {
        // Add class to indicate details are visible
        this.isDetailsOn = true
        // Recover Project Details
        this.projectId = this.$route.params.id
      } else {
        // no parameter
        this.isDetailsOn = false
        this.projectId = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* Layout */
.projectsPage {
  display: flex;
  flex-direction: row;
  height: 100%;

  .projectList {
    position: relative;
    min-height: 100vh;
    background-color: #f0f0f0;
    .projectList__intro {
      display: block;
      padding: $gutter/2;
      padding-top: 80px;
      width: 100vw;
    }
    .projectList__list {
      padding-bottom: 100px;
    }
  }

  .projectDetailsContainer {
    position: relative;
    height: 100vh;
    overflow-y: auto;
    overflow: hidden;
    .projectDetails__intro {
      position: absolute;
      z-index:2;
      width: 100%;
      height: 100vh;
      min-width: 340px;
      text-align: justify;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (min-width: 768px) {
        background: url('../assets/img/projectsimg.png') 20px bottom no-repeat;
      }
      .projectDetails__intro__content {
        display: none;
        width: 300px;
        @media (min-width: 768px) {
          display: block;
        }
      }
    }
    .closeBtnContainer {
      position: absolute;
      width: 100vw;
      .closeBtn {
        position: absolute;
        top: $gutter/2;
        right: $gutter/2;
        z-index: 1;
        .icon {
          position: relative;
          top: 1px;
          margin-left: 5px;
        }
      }
    }
  }

  // LAYOUT
  .projectList {
    width: 100%;
    transition: width 0.5s;
    ul {
      width: calc( 100vw - #{$headerClosedMobileW} );
    }
  }
  .projectDetailsContainer {

    width: 0;
    transition: width 0.5s;
    .content {
      width: calc( 100vw - #{$headerClosedMobileW} );
      height: 100vh;
    }
  }
  .closeBtn {
    display: none;
  }
  @media (min-width: 768px) {
    .closeBtn {
      display: none;
    }
    .projectList {
      width: $projectListNoThumbW;
      ul {
        width: 100%;
      }
      .projectList__intro {
        display: none;
      }
      .projectList__list {
        padding-bottom: 0;
      }
    }
    .projectDetailsContainer {
      padding-top: 0;
      width: calc(100% - #{$projectListNoThumbW});
      .content {
        width: 100%;
      }
    }
  }

  @media (min-width: 1200px) {
    .projectList {
      width: $projectListWithThumbW;
    }
    .projectDetailsContainer {
      width: calc(100% - #{$projectListWithThumbW});
    }
  }

  // Details on
  &.detailsOn {
    .closeBtn {
      display: inline-block;
    }
    .projectList {
      width: 0;
    }
    .projectDetailsContainer {
      width: 100%;
    }
    @media (min-width: 768px) {
      .closeBtn {
        display: none;
      }
      .projectList {
        width: $projectListNoThumbW;
      }
      .projectDetailsContainer {
        width: calc(100% - #{$projectListNoThumbW});
      }
    }

    @media (min-width: 1200px) {
      .projectList {
        width: $projectListWithThumbW;
      }
      .projectDetailsContainer {
        width: calc(100% - #{$projectListWithThumbW});
      }
    }
  }
}

/* Componentes */
.projectList ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.projectDetailsContainer {
  border-left: 1px solid #c2c2c2;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectsPage.vue